﻿import { IBinder, IBehaviorBinding, ICellBinding } from "./ibinder"
import ko from 'knockout';
import $ from 'jquery';
import Utility from "../utility";

export class ExpressionBinder implements IBinder {
  public getElements(row: JQuery): JQuery {
    return row.find("[data-et-expression]");
  }

  public getBinding(cell: JQuery, rowData: Object): ICellBinding {
    var cellName = cell.attr("data-et-expression-key");
    if (cellName == null)
      throw new Error("compute binding must have a [data-et-expression-key] attribute");

    var compute = (rd) => ko.computed({
      read: function(){
        var data = ExpressionBinder.rewriteComputeExpression(cell.data("et-expression"));
        var compute = new Function('row', 'return ' + data);
        return Utility.formatTextIfNumber(compute(this)) || "";
      }
    }, rd);

    return {
      dataName: cellName,
      dataValue: compute(rowData),
      bindingName: "text",
      bindTo: cellName,
      createEmptyValue: (rd) => compute(rd)
    }
  }

  static rewriteComputeExpression(expression: string) {
    //[row.Units] * [row.Price] => this.Units() * this.Price()
    var re = [];
    var propertyName = [];
    var bracketsOpen = false;
    for (var i = 0, len = expression.length; i < len; i++) {
      if (expression[i] === "[") {
        bracketsOpen = true;
        re.push("[");
      }
      else if (expression[i] === "]") {
        bracketsOpen = false;
        re.push(Utility.relativeName(propertyName.join("")));
        propertyName = [];
        re.push("]");
      }
      else if (bracketsOpen)
        propertyName.push(expression[i]);
      else
        re.push(expression[i]);
    }

    return re.join("").replace(/\[/g, "row.").replace(/\]/g, "()");
  }
}